import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { ConsultaSolicitudesDisponiblesDTO } from 'src/app/infraestructure/interfaces/referente/ConsultaSolicitudesDisponiblesDTO';
import { SolicitudCambiarEstadoI } from 'src/app/infraestructure/models/solicitudCambiarEstado.interface';

@Component({
  selector: 'app-seguimiento-solicitudes-servicio',
  templateUrl: './seguimiento-solicitudes-servicio.component.html',
  styleUrls: ['./seguimiento-solicitudes-servicio.component.scss']
})
export class SeguimientoSolicitudesServicioComponent implements OnInit {

  solicitudSeleccionada = {} as ConsultaSolicitudesDisponiblesDTO;
  reloadTable: boolean = false;

  cambiarEstadoSolicitud = {} as SolicitudCambiarEstadoI;
  codeSolicitud: number = 0;

  constructor( config: NgbModalConfig,
               private modalService: NgbModal) 
              { 
                config.backdrop = 'static';
                config.keyboard = false;
                config.size = 'xl';
              }

  ngOnInit(): void {
  }


  onValidate(validate: any) {
    if (validate === 'close') return this.modalService.dismissAll(validate);

    this.modalService.open(validate);
  }

  onCancel(cancel: any) {
    if (cancel === 'close') return this.modalService.dismissAll(cancel);

    this.modalService.open(cancel);
  }
}
